import {configureStore} from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import {combineReducers} from "redux";
import {persistReducer} from 'redux-persist';
import thunk from 'redux-thunk';

import auth from './auth';
import classPlan from './classPlan';
import selectedContent from "./playListDetails";

const reducers = combineReducers({
    auth,
    classPlan,
    selectedContent
});

const persistConfig = {
    key: 'root',
    storage,
    blacklist: ['auth']
};
const persistedReducer = persistReducer(persistConfig, reducers);
export const store = configureStore({
    reducer: persistedReducer,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: [thunk]
});

// export const store = configureStore({
//     reducer: {auth},
// })
